export default __webpack_public_path__ + "static/media/choiceHotel.efb0d2e0.jpg";